import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconName } from '@fortawesome/fontawesome-svg-core';

interface IconProps {
  className?: string;
  name: string;
  solid?: boolean;
}

const Icon = ({ className = '', name, solid = false }: IconProps) => (
  <FontAwesomeIcon className={className} icon={[solid ? 'fas' : 'far', name as IconName]} />
);

export default Icon;
